<template>
  <table>
    <tr>
      <td style="width: 40%">
        <p class="necessary-bold">
          <span
            :class="
              info.BENEF_BASE != null && info.BENEF_BASE.length > 0
                ? 'valid-field'
                : 'unvalid-field'
            "
            >➤</span
          >
          Сведения об основаниях, документе (агентский договор, договор
          комиссии, договор поручения, договор доверительного управления, счет
          иной документ)
        </p>
      </td>
      <td>
        <input
          type="text"
          v-model="info.BENEF_BASE"
          :onchanged="
            info.BENEF_BASE != null && info.BENEF_BASE.length > 80
              ? (info.BENEF_BASE = info.BENEF_BASE.substr(0, 80))
              : info.BENEF_BASE
          "
        />
      </td>
    </tr>
    <tr>
      <td>
        <p>
          <span
            :class="
              info.DOC_NUMBER != null && info.DOC_NUMBER.length > 0
                ? 'valid-field'
                : 'unvalid-field'
            "
            >➤</span
          >
          Номер документа
        </p>
      </td>
      <td>
        <input
          type="text"
          v-model="info.DOC_NUMBER"
          :onchanged="
            info.DOC_NUMBER != null && info.DOC_NUMBER.length > 10
              ? (info.DOC_NUMBER = info.DOC_NUMBER.substr(0, 10))
              : info.DOC_NUMBER
          "
        />
      </td>
    </tr>
    <tr>
      <td>
        <p class="necessary-bold"></p>
        <p>
          <span
            :class="
              info.DOC_DATE != null &&
              info.DOC_DATE.length == 10 &&
              !unvalidDocDate
                ? 'valid-field'
                : 'unvalid-field'
            "
            >➤</span
          >
          Дата документа
        </p>
      </td>
      <td>
        <input
          type="text"
          v-model="info.DOC_DATE"
          v-mask="'##.##.####'"
          placeholder="дд.мм.гггг"
          @input="info.DOC_DATE = checkDate(info.DOC_DATE)"
          @blur="checkDocDate()"
        />
        <p class="necessary-message" v-if="unvalidDocDate">
          Введите корректную дату документа
        </p>
      </td>
    </tr>
    <tr>
      <td class="left-column">
        <p class="necessary-bold">
          <span
            :class="
              info.LAST_NAME != null && info.LAST_NAME.length > 0
                ? 'valid-field'
                : 'unvalid-field'
            "
            >➤</span
          >
          Фамилия
        </p>
      </td>
      <td class="right-column">
        <input
          type="text"
          v-model="info.LAST_NAME"
          :onchanged="
            info.LAST_NAME != null && info.LAST_NAME.length > 80
              ? (info.LAST_NAME = info.LAST_NAME.substr(0, 80))
              : info.LAST_NAME
          "
        />
      </td>
    </tr>
    <tr>
      <td>
        <p class="necessary-bold">
          <span
            :class="
              info.FIRST_NAME != null && info.FIRST_NAME.length > 0
                ? 'valid-field'
                : 'unvalid-field'
            "
            >➤</span
          >
          Имя
        </p>
      </td>
      <td>
        <input
          type="text"
          v-model="info.FIRST_NAME"
          :onchanged="
            info.FIRST_NAME != null && info.FIRST_NAME.length > 80
              ? (info.FIRST_NAME = info.FIRST_NAME.substr(0, 80))
              : info.FIRST_NAME
          "
        />
      </td>
    </tr>
    <tr>
      <td>
        <p>Отчество</p>
      </td>
      <td>
        <input
          type="text"
          v-model="info.SUR_NAME"
          :onchanged="
            info.SUR_NAME != null && info.SUR_NAME.length > 80
              ? (info.SUR_NAME = info.SUR_NAME.substr(0, 80))
              : info.SUR_NAME
          "
        />
      </td>
    </tr>
    <tr>
      <td>
        <p>ИНН (при наличии)</p>
      </td>
      <td>
        <input type="text" v-model="info.INN" v-mask="'############'" />
      </td>
    </tr>
    <tr>
      <td>
        <p>СНИЛС</p>
      </td>
      <td>
        <input type="text" v-model="info.SNILS" v-mask="'###-###-### ##'" />
      </td>
    </tr>
    <tr>
      <td>
        <p class="necessary-bold">
          <span
            :class="info.DUL_DOCTYPE != null ? 'valid-field' : 'unvalid-field'"
            >➤</span
          >
          Тип документа, удостоверяющего личность
        </p>
      </td>
      <td>
        <dropdown
          style="width: 300px"
          :options="docTypes"
          :selected="{ name: info.DUL_DOCTYPE }"
          v-on:updateOption="info.DUL_DOCTYPE = $event.name"
          placeholder="Выберите тип удостоверяющего документа"
        ></dropdown>
      </td>
    </tr>
    <tr>
      <td>
        <p class="necessary-bold">
          <span
            :class="
              info.DUL_SERIAL != null && info.DUL_SERIAL.length > 0
                ? 'valid-field'
                : 'unvalid-field'
            "
            >➤</span
          >
          Серия документа
        </p>
      </td>
      <td>
        <input
          type="text"
          v-model="info.DUL_SERIAL"
          :onchanged="
            info.DUL_SERIAL != null &&
            info.DUL_SERIAL != formatDocNumber(info.DUL_SERIAL)
              ? (info.DUL_SERIAL = formatDocNumber(info.DUL_SERIAL))
              : info.DUL_SERIAL
          "
        />
      </td>
    </tr>
    <tr>
      <td>
        <p class="necessary-bold">
          <span
            :class="
              info.DUL_NUMBER != null && info.DUL_NUMBER.length > 0
                ? 'valid-field'
                : 'unvalid-field'
            "
            >➤</span
          >
          Номер документа
        </p>
      </td>
      <td>
        <input
          type="text"
          v-model="info.DUL_NUMBER"
          :onchanged="
            info.DUL_NUMBER != null &&
            info.DUL_NUMBER != formatDocNumber(info.DUL_NUMBER)
              ? (info.DUL_NUMBER = formatDocNumber(info.DUL_NUMBER))
              : info.DUL_NUMBER
          "
        />
      </td>
    </tr>
    <tr>
      <td>
        <p class="necessary-bold">
          <span
            :class="
              info.DUL_DATE != null &&
              info.DUL_DATE.length == 10 &&
              !unvalidDulDate
                ? 'valid-field'
                : 'unvalid-field'
            "
            >➤</span
          >
          Дата выдачи документа
        </p>
      </td>
      <td>
        <input
          type="text"
          v-model="info.DUL_DATE"
          v-mask="'##.##.####'"
          placeholder="дд.мм.гггг"
          @input="info.DUL_DATE = checkDate(info.DUL_DATE)"
          @blur="checkDulDate()"
        />
        <p class="necessary-message" v-if="unvalidDulDate">
          Введите корректную дату выдачи документа
        </p>
      </td>
    </tr>
    <tr>
      <td>
        <p class="necessary-bold">
          <span
            :class="
              (info.DUL_CODE != null && info.DUL_CODE.length > 0) || hasCode
                ? 'valid-field'
                : 'unvalid-field'
            "
            >➤</span
          >
          Код подразделения
        </p>
        <label>
          <input
            type="checkbox"
            v-model="hasCode"
            id="checkboxEnglishName"
            @click="
              info.DUL_CODE = '';
              info.issuerList = [];
              info.disableIssue = false;
            "
          />
          Код подразделения отсутствует
        </label>
      </td>
      <td>
        <input
          class="input-line"
          type="text"
          v-model="info.DUL_CODE"
          :disabled="hasCode"
          :onchanged="
            info.DUL_CODE != null && info.DUL_CODE.length > 7
              ? (info.DUL_CODE = info.DUL_CODE.substr(0, 7))
              : info.DUL_CODE
          "
          v-mask="'###-###'"
          @input="
            info.DUL_CODE.length == 7 &&
            info.disableIssue != null &&
            !info.disableIssue
              ? getDulIssue(info)
              : (info.disableIssue = false);
            info.issuerList = [];
          "
        />
      </td>
    </tr>
    <tr>
      <td>
        <p class="necessary-bold">Наименование органа, выдавшего документ</p>
      </td>
      <td>
        <dropdown
          style="width: 300px"
          v-if="info.issuerList != null && info.issuerList.length > 1"
          :options="info.issuerList"
          :selected="{ name: 'Выберите наименование' }"
          v-on:updateOption="
            info.DUL_ISSUER = $event.name;
            isUpdate = true;
            $forceUpdate();
          "
        ></dropdown>
        <input
          v-if="info.issuerList == null || info.issuerList.length <= 1"
          type="text"
          v-model="info.DUL_ISSUER"
          :onchanged="
            info.DUL_ISSUER != null && info.DUL_ISSUER.length > 80
              ? (info.DUL_ISSUER = info.DUL_ISSUER.substr(0, 80))
              : info.DUL_ISSUER
          "
          :disabled="info.disableIssue != null && info.disableIssue && !hasCode"
          @focus="
            info.DUL_ISSUER == 'Подразделение не найдено'
              ? (info.DUL_ISSUER = '')
              : info.DUL_ISSUER;
            $forceUpdate();
          "
        />
      </td>
    </tr>

    <tr>
      <td>
        <p class="necessary-bold">
          <span
            :class="
              info.BIRTH_DATE != null &&
              info.BIRTH_DATE.length == 10 &&
              !unvalidBirthDate
                ? 'valid-field'
                : 'unvalid-field'
            "
            >➤</span
          >
          Дата рождения
        </p>
      </td>
      <td>
        <input
          type="text"
          v-model="info.BIRTH_DATE"
          v-bind:class="
            unvalidBirthDate ? 'necessary-unvalid' : 'necessary-valid'
          "
          v-mask="'##.##.####'"
          placeholder="дд.мм.гггг"
          @input="info.BIRTH_DATE = checkDate(info.BIRTH_DATE)"
          @blur="checkBirthDate()"
        />
        <p class="necessary-message" v-if="unvalidBirthDate">
          Введите корректную дату рождения
        </p>
      </td>
    </tr>
    <tr>
      <td>
        <p class="necessary-bold">
          <span
            :class="
              info.BIRTH_PLACE != null && info.BIRTH_PLACE.length > 0
                ? 'valid-field'
                : 'unvalid-field'
            "
            >➤</span
          >
          Место рождения
        </p>
      </td>
      <td>
        <input type="text" v-model="info.BIRTH_PLACE" />
      </td>
    </tr>
    <tr>
      <td>
        <p class="necessary-bold">
          <span
            :class="
              info.CITIZENSHIP != null && info.CITIZENSHIP.length > 0
                ? 'valid-field'
                : 'unvalid-field'
            "
            >➤</span
          >
          Гражданство (подданство) (указываются все страны, в которых физическое
          лицо имеет гражданство)
        </p>
      </td>
      <td>
        <input
          type="text"
          v-model="info.CITIZENSHIP"
          :onchanged="
            info.CITIZENSHIP != null && info.CITIZENSHIP.length > 80
              ? (info.CITIZENSHIP = info.CITIZENSHIP.substr(0, 80))
              : info.CITIZENSHIP
          "
        />
      </td>
    </tr>
    <tr>
      <td>
        <p class="necessary-bold">
          <span
            :class="
              info.REG_ADDRESS != null && info.REG_ADDRESS.length > 0
                ? 'valid-field'
                : 'unvalid-field'
            "
            >➤</span
          >
          Адрес места жительства (регистрации)
        </p>
      </td>
      <td>
        <input
          type="text"
          v-model="info.REG_ADDRESS"
          :onchanged="
            info.REG_ADDRESS != null && info.REG_ADDRESS.length > 1000
              ? (info.REG_ADDRESS = info.REG_ADDRESS.substr(0, 1000))
              : info.REG_ADDRESS
          "
        />
      </td>
    </tr>
    <tr>
      <td>
        <p class="necessary-bold">
          <span
            :class="
              info.FACT_ADDRESS != null && info.FACT_ADDRESS.length > 0
                ? 'valid-field'
                : 'unvalid-field'
            "
            >➤</span
          >
          Адрес места пребывания
        </p>
        <label>
          <input
            type="checkbox"
            v-model="live_like_registration"
            :checked="
              live_like_registration
                ? (info.FACT_ADDRESS = info.REG_ADDRESS)
                : info.FACT_ADDRESS
            "
          />Совпадает с местом жительства
        </label>
      </td>
      <td>
        <input
          type="text"
          v-model="info.FACT_ADDRESS"
          :disabled="live_like_registration"
          :onchanged="
            info.FACT_ADDRESS != null && info.FACT_ADDRESS.length > 1000
              ? (info.FACT_ADDRESS = info.FACT_ADDRESS.substr(0, 1000))
              : info.FACT_ADDRESS
          "
        />
      </td>
    </tr>
    <tr>
      <td>
        <p class="necessary-bold">
          <span
            :class="
              info.POST_ADDRESS != null && info.POST_ADDRESS.length > 0
                ? 'valid-field'
                : 'unvalid-field'
            "
            >➤</span
          >
          Почтовый адрес
        </p>
        <div class="checkboxes">
          <label>
            <input
              type="checkbox"
              v-model="mail_like_addresses[0]"
              :checked="
                !mail_like_addresses[1] && mail_like_addresses[0]
                  ? (info.POST_ADDRESS = info.REG_ADDRESS)
                  : info.POST_ADDRESS
              "
              @click="mail_like_addresses = [mail_like_addresses[0], false]"
            />Совпадает с местом жительства
          </label>
          <label>
            <input
              type="checkbox"
              v-model="mail_like_addresses[1]"
              :checked="
                mail_like_addresses[1] && !mail_like_addresses[0]
                  ? (info.POST_ADDRESS = info.FACT_ADDRESS)
                  : info.POST_ADDRESS
              "
              @click="mail_like_addresses = [false, mail_like_addresses[1]]"
            />Совпадает с местом пребывания
          </label>
        </div>
        <div class="checkboxes"></div>
      </td>
      <td>
        <input
          type="text"
          v-model="info.POST_ADDRESS"
          :disabled="mail_like_addresses[1] || mail_like_addresses[0]"
          :onchanged="
            info.POST_ADDRESS != null && info.POST_ADDRESS.length > 1000
              ? (info.POST_ADDRESS = info.POST_ADDRESS.substr(0, 1000))
              : info.POST_ADDRESS
          "
        />
      </td>
    </tr>
    <tr>
      <td>
        <p>Телефон</p>
      </td>
      <td>
        <input
          type="text"
          v-model="info.PHONE_NUMBER"
          v-mask="'+7 (###) ###-##-##'"
        />
      </td>
    </tr>
    <tr>
      <td>
        <p>Адрес электронной почты</p>
      </td>
      <td>
        <input
          type="text"
          v-bind:class="unvalidEmail ? 'necessary-unvalid' : 'necessary-valid'"
          v-model="info.E_MAIL"
          placeholder="example@mail.com"
          @blur="checkEmail()"
          :onchanged="
            info.E_MAIL != null && info.E_MAIL.length > 100
              ? (info.E_MAIL = info.E_MAIL.substr(0, 100))
              : info.E_MAIL
          "
        />
        <p class="necessary-message" v-if="unvalidEmail">
          Введите корректный адрес электронной почты
        </p>
      </td>
    </tr>
    <tr>
      <td>
        <p class="necessary-bold">
          <span
            :class="
              info.OGRNIP != null &&
              info.OGRNIP.length == '###############'.length
                ? 'valid-field'
                : 'unvalid-field'
            "
            >➤</span
          >
          ОГРНИП
        </p>
      </td>
      <td>
        <input type="text" v-model="info.OGRNIP" v-mask="'###############'" />
      </td>
    </tr>
    <tr>
      <td>
        <p class="necessary-bold">
          <span
            :class="
              info.OGRNIP_DATE != null &&
              info.OGRNIP_DATE.length == 10 &&
              !unvalidORGN
                ? 'valid-field'
                : 'unvalid-field'
            "
            >➤</span
          >
          Дата выдачи ОГРН
        </p>
      </td>
      <td>
        <input
          type="text"
          v-model="info.OGRNIP_DATE"
          v-bind:class="unvalidORGN ? 'necessary-unvalid' : 'necessary-valid'"
          v-mask="'##.##.####'"
          placeholder="дд.мм.гггг"
          @input="info.OGRNIP_DATE = checkDate(info.OGRNIP_DATE)"
          @blur="checkOgrnDate()"
        />
        <p class="necessary-message" v-if="unvalidORGN">
          Введите корректную дату выдачи ОГРН
        </p>
      </td>
    </tr>
    <tr>
      <td>
        <p>
          Сведения о лицензии на право осуществления деятельности, подлежащей
          лицензированию: вид, номер, дата выдачи лицензии; кем выдана; срок
          действия; перечень видов лицензируемой деятельности (при наличии)
        </p>
      </td>
      <td>
        <input
          type="text"
          v-model="info.LICENSE_DATA"
          :onchanged="
            info.LICENSE_DATA != null && info.LICENSE_DATA.length > 80
              ? (info.LICENSE_DATA = info.LICENSE_DATA.substr(0, 80))
              : info.LICENSE_DATA
          "
        />
      </td>
    </tr>
  </table>
</template>

<script>
import dropdown from "vue-dropdowns";
import mask from "../utils/my-mask.js";
import fieldFormatter from "../utils/field-formatter.js";
export default {
  name: "FacesIPTable",
  components: {
    dropdown,
  },
  props: {
    info: {},
    url: String,
  },
  data: () => ({
    mail_like_addresses: [false, false],
    unvalidBirthDate: false,
    unvalidEmail: false,
    unvalidDulDate: false,
    unvalidDocDate: false,
    unvalidORGN: false,
    hasCode: false,
    live_like_registration: false,
    docTypes: [
      { name: "Паспорт гражданина РФ" },
      { name: "Загранпаспорт гражданина РФ" },
      { name: "Удостоверение личности военнослужащего РФ" },
      { name: "Паспорт иностранного гражданина" },
      { name: "Удостоверение беженца" },
      {
        name:
          "Свидетельство о предоставлении временного убежища на территории РФ",
      },
    ],
  }),
  methods: {
    formatDocNumber(field) {
      return fieldFormatter.formatDocNumber(field);
    },
    checkEmail() {
      this.unvalidEmail = mask.emailCheck(this.info.E_MAIL);
    },
    checkDate(date) {
      return mask.date(date);
    },
    async getDulIssue() {
      try {
        this.info.DUL_ISSUER = "";
        if (!this.info.disableIssue) {
          this.info.disableIssue = true;
          let response = await fetch(this.url + "get_passp_issuer_by_code", {
            method: "POST",
            headers: {
              "Content-Type": "application/json;charset=utf-8",
            },
            body: JSON.stringify({
              DUL_CODE: this.info.DUL_CODE,
            }),
          });
          if (response.ok) {
            let data = await response.json();
            if (data.DUL_ISSUER != null) {
              switch (data.DUL_ISSUER.length) {
                case 0:
                  this.info.DUL_ISSUER = "Подразделение не найдено";
                  this.info.disableIssue = false;
                  break;
                case 1:
                  this.info.DUL_ISSUER = data.DUL_ISSUER[0];
                  this.info.disableIssue = true;
                  break;
                default:
                  this.info.issuerList = [];
                  this.info.disableIssue = true;
                  for (let i = 0; i < data.DUL_ISSUER.length; i++) {
                    this.info.issuerList.push({ name: data.DUL_ISSUER[i] });
                  }
                  break;
              }
            } else {
              this.info.DUL_ISSUER = "Подразделение не найдено";
              this.info.disableIssue = false;
            }
          } else throw new Error("Ошибка получения наименования подразделения");
        }
      } catch (e) {
        this.info.disableIssue = false;
        console.log(e);
      }
      this.$forceUpdate();
      this.$emit("updated");
    },
    checkDulDate() {
      let date = new Date();
      let dulDate = this.info.DUL_DATE;

      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();

      let dul_year = parseInt(dulDate.split(".")[2]);
      let dul_months = parseInt(dulDate.split(".")[1]);
      let dul_days = parseInt(dulDate.split(".")[0]);
      if (dulDate.length == 10) {
        this.unvalidDulDate = !(
          dul_year < year ||
          (dul_year == year && dul_months < month) ||
          (dul_year == year && dul_months == month && dul_days < day)
        );
      } else if (dulDate.length == 0) {
        this.unvalidDulDate = false;
      } else {
        this.unvalidDulDate = true;
      }
    },
    checkOgrnDate() {
      let date = new Date();
      let ogrnDate = this.info.OGRNIP_DATE;

      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();

      let ogrn_year = parseInt(ogrnDate.split(".")[2]);
      let ogrn_months = parseInt(ogrnDate.split(".")[1]);
      let ogrn_days = parseInt(ogrnDate.split(".")[0]);
      if (ogrnDate.length == 10) {
        this.unvalidORGN = !(
          ogrn_year < year ||
          (ogrn_year == year && ogrn_months < month) ||
          (ogrn_year == year && ogrn_months == month && ogrn_days < day)
        );
      } else if (ogrnDate.length == 0) {
        this.unvalidORGN = false;
      } else {
        this.unvalidORGN = true;
      }
    },
    checkDocDate() {
      let date = new Date();
      let docDate = this.info.DOC_DATE;

      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();

      let doc_year = parseInt(docDate.split(".")[2]);
      let doc_months = parseInt(docDate.split(".")[1]);
      let doc_days = parseInt(docDate.split(".")[0]);
      if (docDate.length == 10) {
        this.unvalidDocDate = !(
          doc_year < year ||
          (doc_year == year && doc_months < month) ||
          (doc_year == year && doc_months == month && doc_days < day)
        );
      } else if (docDate.length == 0) {
        this.unvalidDocDate = false;
      } else {
        this.unvalidDocDate = true;
      }
    },
    checkInformation() {
      let a = true;
      a =
        a &&
        this.info.BENEF_BASE != null &&
        this.info.DOC_DATE != null &&
        this.info.DOC_NUMBER != null &&
        this.info.BIRTH_DATE != null &&
        this.info.BIRTH_DATE.length == 10 &&
        this.info.DOC_DATE.length == 10 &&
        this.info.DUL_DATE != null &&
        this.info.DUL_DATE.length == 10 &&
        this.info.OGRNIP_DATE != null &&
        this.info.OGRNIP_DATE.length == 10 &&
        this.info.DUL_NUMBER != null &&
        this.info.DUL_SERIAL != null &&
        this.info.DUL_ISSUER != null &&
        this.info.DUL_ISSUER != "Подразделение не найдено" &&
        this.info.BIRTH_PLACE != null &&
        this.info.CITIZENSHIP != null &&
        this.info.REG_ADDRESS != null &&
        this.info.FACT_ADDRESS != null &&
        this.info.POST_ADDRESS != null &&
        ((this.info.DUL_CODE != null && this.info.DUL_CODE.length > 0) ||
          this.hasCode) &&
        this.info.OGRNIP != null &&
        this.info.OGRNIP.length >= 12 &&
        this.info.LAST_NAME != null &&
        this.info.FIRST_NAME != null &&
        this.info.LAST_NAME.length *
          this.info.BENEF_BASE.length *
          this.info.DOC_NUMBER.length *
          this.info.FIRST_NAME.length *
          this.info.DUL_NUMBER.length *
          this.info.DUL_SERIAL.length *
          this.info.DUL_ISSUER.length *
          this.info.BIRTH_PLACE.length *
          this.info.CITIZENSHIP.length *
          this.info.REG_ADDRESS.length *
          this.info.FACT_ADDRESS.length *
          this.info.POST_ADDRESS.length >
          0 &&
        !this.unvalidBirthDate &&
        !this.unvalidDulDate &&
        !this.unvalidORGN &&
        !this.unvalidDocDate &&
        (this.info.E_MAIL == null ||
          this.info.E_MAIL.length == 0 ||
          !this.unvalidEmail) &&
        (this.info.PHONE_NUMBER == null ||
          this.info.PHONE_NUMBER.length == 0 ||
          this.info.PHONE_NUMBER.length == 18);
      this.info.valid = a;
      this.$emit("updated");
    },
    checkBirthDate() {
      let date = new Date();
      let birthDate = this.info.BIRTH_DATE;

      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();

      let dul_year = parseInt(birthDate.split(".")[2]);
      let dul_months = parseInt(birthDate.split(".")[1]);
      let dul_days = parseInt(birthDate.split(".")[0]);
      if (birthDate.length == 10) {
        this.unvalidBirthDate = !(
          dul_year < year ||
          (dul_year == year && dul_months < month) ||
          (dul_year == year && dul_months == month && dul_days < day)
        );
      } else if (birthDate.length == 0) {
        this.unvalidBirthDate = false;
      } else {
        this.unvalidBirthDate = true;
      }
    },
  },
  updated() {
    this.checkInformation();
  },
  created() {
    this.info.issuerList = [];
    this.checkInformation();
    this.$emit("updated");
  },
};
</script>

<style scoped>
input[type="text"] {
  border: none;
  width: 100%;
  border-bottom: 1px solid #cccccc;
  margin-left: 0px;
}
input[type="text"]:focus {
  border-bottom: 1px solid #06569b;
  outline: none;
}
.left-column {
  width: 35%;
  display: flex;
  flex-direction: column;
}
.right-column {
  width: 70%;
}
.checkboxes {
  display: flex;
  flex-direction: column;
}
table {
  border-collapse: collapse;
  padding: 0px 5px;
  width: 100%;
}
tr {
  border-top: 1px solid black;
  border-bottom: 1px solid black;
}
.necessary {
  color: red;
}
.necessary-message {
  color: red;
  font-size: 12px;
}
p {
  padding-right: 10px;
}
</style>
